import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'
import { botDeliveriesPersistence, botDeliveriesSearchSchema } from '@/features/bot/bot-deliveries-search.ts'
import { botRunsPersistence, botRunsSearchSchema } from '@/features/bot/bot-runs-search.ts'
import { BotDetail } from '@/features/bot/index.ts'

export const Route = createFileRoute('/_authenticated/system-management/bots/$botId')({
  validateSearch: z.object({
    runsQuery: botRunsSearchSchema.optional(),
    deliveriesQuery: botDeliveriesSearchSchema.optional(),
    recordType: z.enum(['push', 'collection']).optional(),
    tab: z.enum(['basic', 'permissions', 'credentials', 'training', 'runs', 'push']).catch('basic').default('basic')
  }),
  component: BotDetail,
  beforeLoad: ({ context, search, params, preload }) => {
    if (preload || (search.runsQuery && search.deliveriesQuery)) return
    const runsQuery =
      search.runsQuery ??
      botRunsPersistence.store.getState().searches[context.currentSession.id] ??
      botRunsSearchSchema.parse({})
    const deliveriesQuery =
      search.deliveriesQuery ??
      botDeliveriesPersistence.store.getState().searches[context.currentSession.id] ??
      botDeliveriesSearchSchema.parse({})
    throw redirect({
      to: '/system-management/bots/$botId',
      params,
      search: { ...search, runsQuery, deliveriesQuery },
      replace: true
    })
  }
})
